import { Deck, DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { DeckGroup } from "@ponder-features/user/decks/deck/group/deck-group";
import { environment } from "../../../../../environments/environment";

export class MagicDeckGroupPlaneswalkers extends DeckGroup {
    public constructor() {
        super("Planeswalkers", `${environment.ponderImageBaseUrl}/magic/set/hou.svg`);
    }
    
    public override isValid(deck: Deck, card: DeckCard): boolean {
        if (card.card.item.data?.magic) {
            var frontFace = card.card.item.data.magic.faces![0];

            if (frontFace.typeLine?.includes("Planeswalker")) {
                return true;
            }
        }

        return false;
    }
}